// extracted by mini-css-extract-plugin
module.exports = {"Julia":"TextGroupSectionE_Julia__3XDd7","TextContainer":"TextGroupSectionE_TextContainer__39P2J"};